import { MutationTree } from 'vuex';
import { UserState } from './../types';
import { IBoatControlUser, ISignInResponse } from '@/common/apis/AccountApi';
import Vue from 'vue';

export const mutations: MutationTree<UserState> = {
    userLoggedIn(state, response: ISignInResponse) {
        state.isLoading = false;
        state.error = undefined;
        state.jwtToken = response.token;
        state.jwtTokenExpires = response.expires;

        Vue.set(state, 'user', response.user);
        // state.user = response.user;

    },
    userLoggedInFailed(state, error: string) {
        state.isLoading = false;
        state.error = error;
        state.jwtTokenExpires = undefined;
        state.jwtToken = undefined;
        Vue.set(state, 'user', undefined);
        // state.user = undefined;
    },
    userLoggedOut(state) {
        state.isLoading = false;
        state.error = undefined;
        state.jwtTokenExpires = undefined;
        state.jwtToken = undefined;
        Vue.set(state, 'user', undefined);
        // state.user = undefined;
    },
    userLoggingIn(state) {
        state.user = undefined;
        state.isLoading = true;
        state.error = undefined;
        state.jwtTokenExpires = undefined;
        state.jwtToken = undefined;

        Vue.set(state, 'user', undefined);
        // state.user = undefined;

    },
    setLastVisitedUrl(state, url: string) {
        Vue.set(state, 'lastVisitedUrl', url);
    },
};
